import React from 'react';

import type { Language } from 'src/enums/language';
import { getDisplayTextForLanguage, getFlagIconForLanguage } from 'src/enums/language';

import SiteConsumer from '../../../context/site-consumer';
import ExpandIcon from '../../icons/expand';

import * as styles from './language-item.module.scss';

type LanguageItemChevron =
  | {
      withChevron: true;
      isChevronExpanded?: boolean;
    }
  | {
      withChevron?: false;
      isChevronExpanded?: undefined;
    };

type LanguageItemProps = {
  language: Language;
} & LanguageItemChevron;

const LanguageItem: React.FC<LanguageItemProps> = ({
  language,
  withChevron,
  isChevronExpanded,
}) => (
  <SiteConsumer>
    {({ styling, isMeridian }) => (
      <div className={styles.item}>
        {getFlagIconForLanguage(language, { size: '1rem' })}
        <div className={styles.text}>{getDisplayTextForLanguage(language)}</div>
        {withChevron && (
          <ExpandIcon
            fill={isMeridian ? styling.colors.capeCod : styling.colors.highlightText}
            size="1rem"
            isExpanded={isChevronExpanded}
          />
        )}
      </div>
    )}
  </SiteConsumer>
);

export default LanguageItem;
